/**
 * @file
 * @author
 **/
/**
 * @file
 * @author
 **/
/**
 * Created by Administrator on 2017/7/6.
 */
import React, {PropTypes} from 'react';
import {Carousel, Button} from 'antd';
import * as Actions from '../actions';
import {Link} from 'react-router';

class MyCarousel extends React.Component {
    constructor(prop, context) {
        super(prop, context);
        this.onChange = this.onChange.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.getOwnState = this.getOwnState.bind(this);
        this.bind = this.load.bind(this);
        this.state = this.getOwnState();
        this.load();
    }

    getOwnState() {
        return {
            topBlogList: this.context.store.getState().mycarousel.topBlogList,
            // toggle: this.context.store.getState().home.collapsed
        };
    }

    onChange() {
        this.setState(this.getOwnState());
    }

    componentDidMount() {
        this.context.store.subscribe(this.onChange);
    }

    load() {
        this.context.store.dispatch(Actions.LoadCarousel());
    }

    render() {
        let that = this;
        return (
            this.state.topBlogList ?
                <div style={that.context.store.getState().home.collapsed ? {
                    margin: '0 auto',
                    marginTop: '20px',
                    width: '1253px',
                    height: '490px'
                } : {
                    margin: '0 auto',
                    marginTop: '20px',
                    width: '1117px',
                    height: '490px'
                }}>
                    <Carousel autoplay>
                        {
                            this.state.topBlogList.map(function (cont, index) {
                                return <div key={cont.blogId} style={that.state.toggle ? {
                                    width: '100%',
                                    height: '490px',
                                    backgroundImage: 'url(' + cont.titleImgUrl + ')',
                                    backgroundSize: `cover`
                                } : {
                                    height: '490px',
                                    backgroundImage: 'url(' + cont.titleImgUrl + ')',
                                    backgroundSize: `cover`
                                }}/>
                            })
                        }
                    </Carousel>
                </div> : <div/>
        );
    }
}

MyCarousel.contextTypes = {
    store: PropTypes.object
}

export default MyCarousel;



// WEBPACK FOOTER //
// ./src/Component/MyCarousel/views/mycarousel.js